export default [
  {
    path: '/committee/list',
    name: 'committee-list',
    component: () => import('@/views/committee/index.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Committee List',
      breadcrumb: [{ title: 'Dashboard', url: '/dashboard' }, { title: 'Committee' }, { title: 'Committee List', active: true }],
      permissions: ['committee_view']
    }
  },
  {
    path: '/committee/add',
    name: 'create-committee',
    component: () => import('@/views/committee/action.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Add committee',
      parent: 'committeeList',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Committee', url: '/committee/list' },
        { title: 'Add committee', active: true }
      ],
      permissions: ['committee_create']
    }
  },
  {
    path: '/committee/:id/edit',
    name: 'edit-committee',
    component: () => import('@/views/committee/action.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Edit committee',
      parent: 'committeeList',
      // breadcrumb: [
      //   { title: 'Dashboard', url: '/dashboard' },
      //   { title: 'Committee', url: '/committee/list' },
      //   { title: 'Edit committee', active: true }
      // ],
      permissions: ['committee_edit']
    }
  },
  {
    path: '/committee/:id/access-users',
    name: 'access-users-committee',
    component: () => import('@/views/committee/accessUser/index.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Access Users',
      parent: 'committeeList',
      // breadcrumb: [
      //   { title: 'Dashboard', url: '/dashboard' },
      //   { title: 'Committee', url: '/committee/list' },
      //   { title: 'Access Users', active: true }
      // ],
      permissions: ['committee_edit']
    }
  }
]
